import { render, staticRenderFns } from "./checkrecord.vue?vue&type=template&id=0e12f0ce&scoped=true&"
import script from "./checkrecord.vue?vue&type=script&lang=js&"
export * from "./checkrecord.vue?vue&type=script&lang=js&"
import style0 from "./checkrecord.vue?vue&type=style&index=0&id=0e12f0ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e12f0ce",
  null
  
)

export default component.exports